/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 8/12/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

// 枚举扩展方法
Number.prototype.hasFlag = function(flag) {
  return Boolean(this & flag);
};

Number.prototype.addFlag = function() {
  let result = this;
  Array.prototype.forEach.call(arguments, function(flag) {
    result = result | flag;
  });
  return result;
};

Number.prototype.toggleFlag = function(flag, value) {
  if ("undefined" === typeof value || null == value) {
    return this ^ flag;
  } else {
    if (value) {
      return this.addFlag(flag);
    } else {
      return this.removeFlag(flag);
    }
  }
};

Number.prototype.removeFlag = function() {
  let result = this;
  Array.prototype.forEach.call(arguments, function(flag) {
    result = result.addFlag(flag).toggleFlag(flag);
  });
  return result;
};

Number.prototype.changeFlag = function(addFlag, removeFlag) {
  return this.addFlag(addFlag).removeFlag(removeFlag);
};
